import { Box, Card, Typography } from "@mui/material";
import React from "react";

// A settings card: icon, title and description on top, content below. Same look as the System section's cards.
export const SettingsCard = ({
  icon,
  title,
  description,
  action,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}) => (
  <Card elevation={0} sx={{ border: "1px solid #e5e7eb", borderRadius: 3, boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)" }}>
    <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", p: { xs: 2, sm: 2.5 }, borderBottom: "1px solid #eef2f6" }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "rgba(25, 118, 210, 0.08)",
          color: "primary.main",
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#0f172a" }}>{title}</Typography>
        <Typography sx={{ fontSize: 13.5, color: "text.secondary", mt: 0.25 }}>{description}</Typography>
      </Box>
      {action}
    </Box>
    <Box sx={{ p: { xs: 2, sm: 2.5 } }}>{children}</Box>
  </Card>
);
